import React, { useState } from "react";
import FormHeader from "../form/Header";
import {ExpandIcon, CollapseIcon } from "../../assets/icons/Icons";
import FormSection from "../form/Section";
import ListInputs from "../form/ListInputs";
import ListInput from "../form/ListInput";
import CopyableText from "../form/CopyableText";
import CopyableInput from "../form/CopyableInput";
import CustomSelect from "../form/CustomSelect";
import {useTranslation} from "react-i18next";

const EditCardholder = ({ cardholder }) => {

    const { t } = useTranslation();

    const [collapsedAll, setCollapsedAll] = useState(false);

    const toggleCollapseAll = (e) => {
        e.preventDefault();
        setCollapsedAll(!collapsedAll);
    }

    return (
        <form method="post">
            <div className="row mb-5">
                <div className="col-xs-6">
                    <FormHeader title={t("Cardholder Details")} description={t("Update your cardholder details here.")}></FormHeader>
                </div>
                <div className="col-xs-6 text-right">
                    {collapsedAll ?
                        <a href="#" className="btn btn-primary btn-medium"
                           onClick={toggleCollapseAll}><ExpandIcon/>{t("Expand All")}</a>
                        :
                        <a href="#" className="btn btn-secondary btn-medium"
                             onClick={toggleCollapseAll}><CollapseIcon/>{t("Collapse All")}</a>
                    }
                </div>
            </div>

            <FormSection title={t("Cardholder")} collapsible collapsed={collapsedAll}>
                <ListInputs>
                    <ListInput title={t("Cardholder ID")}>
                        <CopyableText text={cardholder.id}/>
                    </ListInput>
                    <ListInput title={t("User Full Name")}>
                        <CopyableInput text={cardholder.username}/>
                    </ListInput>
                    <ListInput title={t("External Tag")}>
                        <CopyableText text={cardholder.external_tag}/>
                    </ListInput>
                    <ListInput title={t("Processor Reference")}>
                        <CopyableText text={cardholder.primary_processor_reference}/>
                    </ListInput>
                    <ListInput title={t("Email")}>
                        <CopyableInput text={cardholder.email}/>
                    </ListInput>
                    <ListInput title={t("Phone")}>
                        <CopyableInput text={cardholder.phone}/>
                    </ListInput>
                    <ListInput title={t("Date of Birth")}>
                        <CopyableInput text={cardholder.date_of_birth}/>
                    </ListInput>
                </ListInputs>
            </FormSection>

            <FormSection title={t("Address")} collapsible collapsed={collapsedAll}>
                <ListInputs>
                    <ListInput title={t("Address 1")}>
                        <CopyableInput text={cardholder.address1}/>
                    </ListInput>
                    <ListInput title={t("Address 2")}>
                        <CopyableInput text={cardholder.address2}/>
                    </ListInput>
                    <ListInput title={t("City")}>
                        <CopyableInput text={cardholder.city}/>
                    </ListInput>
                    <ListInput title={t("Province")}>
                        <CopyableInput text={cardholder.state}/>
                    </ListInput>
                    <ListInput title={t("Postal Code")}>
                        <CopyableInput text={cardholder.postal_code}/>
                    </ListInput>
                    <ListInput title={t("Country")}>
                        <CopyableInput text={cardholder.country}/>
                    </ListInput>
                </ListInputs>
            </FormSection>

            <FormSection title={t("Accounts")} collapsible collapsed={collapsedAll}>
                <ListInputs>
                    <ListInput title={t("Account ID")}>
                        <CopyableText text={cardholder.account_id}/>
                    </ListInput>
                    <ListInput title={t("Program ID")}>
                        <CopyableText text={cardholder.program_id}/>
                    </ListInput>
                    <ListInput title={t("Program Name")}>
                        <CustomSelect
                            placeholder={<div>Select program</div>}
                            options={[
                                {
                                    value: 'physical_card',
                                    label: t('Physical Card')
                                },
                                {
                                    value: 'virtual_card',
                                    label: t('Virtual Card')
                                },
                            ]}
                            value={{
                                value: 'physical_card',
                                label: t('Physical Card')
                            }}
                        />
                    </ListInput>
                    <ListInput title={t("Status")}>
                        <CopyableInput text={cardholder.status}/>
                    </ListInput>
                    <ListInput title={t("Created at")}>
                        <CopyableInput text={cardholder.created_at}/>
                    </ListInput>
                    <ListInput title={t("Balance")}>
                        <CopyableInput text={cardholder.load_amount}/>
                    </ListInput>
                </ListInputs>
            </FormSection>

            <FormSection title={t("Value Loads")} collapsible collapsed={collapsedAll}>
                <ListInputs>
                    <ListInput title={t("ID")}>
                        <CopyableText text={cardholder.value_loads}/>
                    </ListInput>
                    <ListInput title={t("External Tag")}>
                        <CopyableText text={cardholder.external_tag}/>
                    </ListInput>
                    <ListInput title={t("Value Loads Processor Reference Number (PRN)")}>
                        <CopyableText text={cardholder.value_loads_processor}/>
                    </ListInput>
                    <ListInput title={t("Amount")}>
                        <CopyableText text={cardholder.load_amount}/>
                    </ListInput>
                    <ListInput title={t("Created on")}>
                        <CopyableText text={cardholder.created_on_gte}/>
                    </ListInput>
                </ListInputs>
            </FormSection>

        </form>
    );
};
export default EditCardholder;